<template>
  <v-textarea :readonly="readonly" auto-grow v-model="model[`${prop.value}`]" :label="prop.text" :clearable="!readonly"
    :color="prop.color">
  </v-textarea>

</template>

<style scoped>

</style>

<script>
  import TextArea from "./textArea.ts";
  export default TextArea;
</script>